var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAdmirers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "81px",
    viewBox: "0 0 92 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade-6",
    transform: "translate(-142.000000, -116.000000)",
    fillRule: "nonzero",
    stroke: "#CCCCCC",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upgrade/View-Admirer",
    transform: "translate(113.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8718143,39.0016924 C85.900844,38.9624908 79.2736075,42.1782438 74.7833333,47.7788179 C70.3209957,42.1399214 63.6754967,38.9153069 56.6948523,39.0016924 C43.6085467,39.0016924 33,50.1439994 33,63.8887317 C33,87.4425369 72.1388186,110.440828 73.7255274,111.329651 C74.3658432,111.779005 75.2008235,111.779005 75.8411392,111.329651 C77.4278481,110.440828 116.566667,87.7758454 116.566667,63.8887317 C116.566667,57.2882785 114.070252,50.9581627 109.626605,46.2909374 C105.182958,41.6237122 99.1560799,39.0016924 92.8718143,39.0016924 Z",
    id: "Mask"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAdmirers);
export default __webpack_public_path__ + "static/media/view_admirers.dcc1ec095cc52897738fd056a71d6615.svg";
export { ForwardRef as ReactComponent };